import XHRLoader from './xhr-loader';

export default class Localization {
  constructor(player) {
    this.player = player;
    this.messages = null;
  }

  setMessages(value) {
    this.messages = value;
  }

  onLoad(data) {
    try {
      const response = JSON.parse(data);
      if (response.result === 'ok') {
        this.messages = response.data;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e.message);
    }
  }

  onError(message) {
    // eslint-disable-next-line no-console
    console.warning(`Could't load localization: ${message}`);
  }

  getText(key) {
    let result = '';
    if (this.player) {
      const info = this.player.get('videoInfo');
      if (info && info.messages && info.messages[key]) {
        result = info.messages[key];
      }
    } else if (this.messages) {
      result = this.messages[key];
    }

    return result;
  }

  load(pUrl) {
    const loader = new XHRLoader();
    loader.load(pUrl, this.onLoad, this.onError);
  }

  loadDefault(pLang) {
    const loader = new XHRLoader();
    loader.load(
      `//embed.megogo.net/aprx/configuration/interface?place=STREAM&lang=${pLang}`,
      this.onLoad,
      this.onError
    );
  }
}
